(() => {
  'use strict';
  const cfg = window.azHomeExperiment;
  if (!cfg || !cfg.enabled || window.Shopify?.designMode) return;
  const variants = ['gallery'];
  const key = 'az_home_20261011';
  const url = new URL(location.href);
  const preview = cfg.preview || url.searchParams.has('az_preview') || url.searchParams.has('preview_theme_id');
  const home = cfg.pageType === 'index';
  if (!preview && home && cfg.variant !== 'gallery') {
    url.searchParams.set('view', 'az-gallery');
    location.replace(url.toString());
    return;
  }
  let assignment = null, started = false, pendingCart = false;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function read() {
    try {
      const a = JSON.parse(localStorage.getItem(key));
      return a && variants.includes(a.variant) && a.expires > Date.now() ? a : null;
    } catch (_) { return null; }
  }
  function event(name, extra = {}) {
    if (!assignment || preview || !allowed()) return false;
    if (typeof window.analyzelyGtag !== 'function') return false;
    window.analyzelyGtag('event', 'az_home_' + assignment.variant + '_' + name, {
      send_to: 'G-H3BDVR7V48', experiment_id: key, variant_id: assignment.variant,
      transport_type: 'beacon', ...extra
    });
    return true;
  }
  async function stampCart() {
    if (!assignment || preview || !allowed() || pendingCart) return;
    pendingCart = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {credentials: 'same-origin'});
      if (!response.ok) return;
      const cart = await response.json();
      if (cart.attributes?.az_home_experiment === key && cart.attributes?.az_home_variant === assignment.variant) return;
      await fetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({attributes: {az_home_experiment: key, az_home_variant: assignment.variant}})});
    } catch (_) {} finally { pendingCart = false; }
  }
  function stampForms() {
    if (!assignment || preview || !allowed()) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      for (const [name, value] of Object.entries({'properties[_az_home_experiment]': key, 'properties[_az_home_variant]': assignment.variant})) {
        let input = [...form.elements].find(x => x.name === name);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
        input.value = value;
      }
    });
  }
  function begin() {
    if (preview || (started && assignment) || !allowed() || /bot|crawler|spider|lighthouse|headless/i.test(navigator.userAgent)) return;
    assignment = read();
    if (!assignment && !home) return;
    if (!assignment) {
      const r = new Uint32Array(1); crypto.getRandomValues(r);
      assignment = {variant: variants[Math.floor(r[0] / 4294967296 * variants.length)], expires: Date.now() + 30 * 86400000};
      try { localStorage.setItem(key, JSON.stringify(assignment)); }
      catch (_) { assignment = null; return; }
    }
    if (home && cfg.variant !== assignment.variant) {
      url.searchParams.set('view', 'az-' + assignment.variant);
      location.replace(url.toString()); return;
    }
    // Every arm takes the same initial redirect, including the control.
    if (home && !url.searchParams.get('view')?.startsWith('az-')) {
      url.searchParams.set('view', 'az-' + assignment.variant);
      location.replace(url.toString()); return;
    }
    window.azHomeAssignment = {experiment: key, variant: assignment.variant};
    // Restore attribution after re-consent without attaching duplicate listeners.
    if (started) { stampForms(); stampCart(); return; }
    started = true;
    const exposureKey = key + ':exposure:' + assignment.variant;
    function expose() {
      if (!home || !allowed()) return;
      try { if (sessionStorage.getItem(exposureKey)) return; } catch (_) {}
      if (event('exposure')) { try { sessionStorage.setItem(exposureKey, '1'); } catch (_) {} }
    }
    expose();
    let retries = 0;
    const retry = setInterval(() => { expose(); if (++retries >= 10) clearInterval(retry); }, 1000);
    if (cfg.pageType === 'product') event('product_view', {item_id: String(cfg.productId || '')});
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stampForms, {once: true}); else stampForms();
    stampCart();
    document.addEventListener('click', e => {
      const link = e.target.closest('a');
      if (e.target.closest('[data-preview]')) event('preview');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (/^mailto:|^tel:|\/pages\/contact/.test(href)) event('inquiry_click');
      else if (/\/products\//.test(href)) event('product_click');
      else if (/pdf-download-section/.test(href)) event('catalogue_click');
      else if (link.matches('[data-tenschert], .tenschert-label')) event('tenschert_click');
    });
    document.addEventListener('submit', e => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.action.includes('/cart/add')) { stampForms(); event('add_attempt'); stampCart(); }
      const type = form.querySelector('[name="form_type"]')?.value;
      if (type === 'customer') event('signup_attempt');
      if (type === 'contact') event('inquiry_attempt');
    }, true);
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (allowed()) begin();
    else {
      try { localStorage.removeItem(key); } catch (_) {}
      document.querySelectorAll('input[name="properties[_az_home_experiment]"],input[name="properties[_az_home_variant]"]').forEach(e=>e.remove());
      assignment = null;
      delete window.azHomeAssignment;
    }
  });
  if (window.Shopify?.customerPrivacy) begin();
  else window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) begin(); });
})();
